import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "lengthValidation",
    "lowercaseValidation",
    "uppercaseValidation",
    "numericalValidation",
    "characterValidation",
    "encryptedPrivateKey",
  ];

  connect() {
    this.isValid = false;
  }

  validate(event) {
    const input = event.currentTarget;
    const minlength = parseInt(input.getAttribute("minlength"));
    const pattern = input.getAttribute("pattern");
    // => "^(?=.*[a-z].*[a-z])(?=.*[A-Z].*[A-Z])(?=.*[0-9].*[0-9])(?=.*[!@#$%^&*_=+-].*[!@#$%^&*_=+-]).+$"
    const validations = pattern.match(/\(\?\=.*?\)/g);
    // => ["(?=.*[a-z].*[a-z])", "(?=.*[A-Z].*[A-Z])", "(?=.*[0-9].*[0-9])", "(?=.*[!@#$%^&*_=+-].*[!@#$%^&*_=+-])"]
    const lowercaseValidation = validations.find((v) => v.includes("[a-z]"));
    const uppercaseValidation = validations.find((v) => v.includes("[A-Z]"));
    const numericalValidation = validations.find((v) => v.includes("[0-9]"));
    const characterValidation = validations.find((v) => v.includes("[!@#$%^&*_=+-]"));

    const lengthValid = this.#validateLength(input, minlength);
    const lowercaseValid = this.#validateLowercase(input, lowercaseValidation);
    const uppercaseValid = this.#validateUppercase(input, uppercaseValidation);
    const numericalValid = this.#validateNumerical(input, numericalValidation);
    const characterValid = this.#validateCharacter(input, characterValidation);
    
    this.isValid = lengthValid && lowercaseValid && uppercaseValid && numericalValid && characterValid;
  }

  #validateLength(input, minlength) {
    const validationIcon = this.lengthValidationTarget.querySelector("svg use");
    const isValid = input.value.length >= minlength;
    if (isValid) {
      validationIcon.setAttribute("href", "#valid");
      validationIcon.setAttribute("fill", "green");
    } else {
      validationIcon.setAttribute("href", "#invalid");
      validationIcon.setAttribute("fill", "red");
    }
    return isValid;
  }

  #validateLowercase(input, pattern) {
    const regexp = new RegExp(pattern + ".+");
    const validationIcon = this.lowercaseValidationTarget.querySelector("svg use");
    const isValid = regexp.test(input.value);
    if (isValid) {
      validationIcon.setAttribute("href", "#valid");
      validationIcon.setAttribute("fill", "green");
    } else {
      validationIcon.setAttribute("href", "#invalid");
      validationIcon.setAttribute("fill", "red");
    }
    return isValid;
  }

  #validateUppercase(input, pattern) {
    const regexp = new RegExp(pattern + ".+");
    const validationIcon = this.uppercaseValidationTarget.querySelector("svg use");
    const isValid = regexp.test(input.value);
    if (isValid) {
      validationIcon.setAttribute("href", "#valid");
      validationIcon.setAttribute("fill", "green");
    } else {
      validationIcon.setAttribute("href", "#invalid");
      validationIcon.setAttribute("fill", "red");
    }
    return isValid;
  }

  #validateNumerical(input, pattern) {
    const regexp = new RegExp(pattern + ".+");
    const validationIcon = this.numericalValidationTarget.querySelector("svg use");
    const isValid = regexp.test(input.value);
    if (isValid) {
      validationIcon.setAttribute("href", "#valid");
      validationIcon.setAttribute("fill", "green");
    } else {
      validationIcon.setAttribute("href", "#invalid");
      validationIcon.setAttribute("fill", "red");
    }
    return isValid;
  }

  #validateCharacter(input, pattern) {
    const regexp = new RegExp(pattern + ".+");
    const validationIcon = this.characterValidationTarget.querySelector("svg use");
    const isValid = regexp.test(input.value);
    if (isValid) {
      validationIcon.setAttribute("href", "#valid");
      validationIcon.setAttribute("fill", "green");
    } else {
      validationIcon.setAttribute("href", "#invalid");
      validationIcon.setAttribute("fill", "red");
    }
    return isValid;
  }
}
